import {Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {Promo} from "../../services/promo.service";
import {finalize} from "rxjs/operators";
import {UtilService} from "../../services/util.service";
import {PromoService} from "../../services/promo.service";
import {DateTime} from 'luxon';
import {MatCheckboxChange} from "@angular/material/checkbox";
import {StateService} from "../../services/state.service";
import {Router} from "@angular/router";

@Component({
    templateUrl: './promos.component.html',
    styleUrls: ['./promos.component.css']
})
export class PromosComponent implements OnInit {

    readonly columnsToDisplay = ['code', 'discount', 'left', 'expires', 'institutional', 'disabled', 'exhausted',
                                 'expired', 'actions'];
    readonly INITIAL_PAGE_INDEX = 0;
    readonly INITIAL_PAGE_SIZE = 10;

    @ViewChild('paginator') paginator: MatPaginator;
    initializing: boolean = false;
    promoRange: Promo[] = [];
    allPromos: Promo[] = [];
    excludeInstitutional: boolean;
    excludeInactive: boolean;


    constructor(private promoService: PromoService,
                private state: StateService,
                private router: Router,
                private utilService: UtilService) {
        const xInst = this.state.get('xInstitutional');
        this.excludeInstitutional =  xInst !== undefined? xInst : true;
        const xInactive = this.state.get('xInactive');
        this.excludeInactive = xInactive !== undefined? xInactive : true;
    }

    ngOnInit(): void {
        this.refresh();
    }

    private refresh() {
        this.initializing = true;
        this.promoService.getAll().pipe(
            finalize(() => {this.initializing=false})
        ).subscribe((promos) => {
            this.allPromos = promos;
            this.updatePromoRange();
        }, this.utilService.getErrorHandler("Error retrieving promos"));
    }

    instFilterChanged(ev:MatCheckboxChange) {
        this.excludeInstitutional = !ev.checked;
        this.state.set('xInstitutional', this.excludeInstitutional);
        this.updatePromoRange();
    }

    inactiveFilterChanged(ev:any) {
        this.excludeInactive = !ev.checked;
        this.state.set('xInactive', this.excludeInactive);
        this.updatePromoRange();
    }

    get promos(): Promo[] {
        return this.allPromos.filter((p) => (!this.excludeInstitutional || !p.institutional) && (!this.excludeInactive || !p.inactive));
    }

    private updatePromoRange() {
        const pageSize = this.paginator? this.paginator.pageSize : this.INITIAL_PAGE_SIZE;
        const pageIndex = this.paginator? this.paginator.pageIndex : this.INITIAL_PAGE_INDEX;
        const offset = pageIndex * pageSize;
        this.promoRange = this.promos.slice(offset, offset + pageSize);
    }

    pageChanged(ev: PageEvent) {
        this.updatePromoRange();
    }

    formatType(promo: Promo): string {
        switch (promo.type) {
            case 'amount_off':  return "$ off";
            case 'percent_off': return "% off";
            default: return "??";
        }
    }

    formatFlag(flag: boolean): string {
        return flag? 'Y' : 'N';
    }

    formatTime(timestamp: string): string {
        if (!timestamp)
            return "";
        const dt = DateTime.fromSQL(timestamp);
        return dt.toFormat('ff');
    }

    edit(promo: Promo) {
        this.state.set('promo', promo);
        this.router.navigateByUrl('/promo').then();
    }

    back() {
        this.router.navigateByUrl('/').then();
    }

    newPromo() {
        let p: Promo = {
            code: '',
            type: 'percent_off',
            discount: 0,
            initial_inventory: 0,
            inventory: 0
        };
        this.edit(p);
    }
}
